import React from 'react'
import PropTypes from 'prop-types'

class Fees extends React.Component {

  is_third_party_submission(fee) {
    return fee.due_at == 'Submission (Third Party Payable)'
  }

  bp_fees() {
    const initiationFees = [
      { id: "agent-init", paid_by: "Agent / Attorney", name: "Single-Application Initiation Fee *", amount: this.props.brokerPackageInitiationFee, due_at: "Initiation" },
      { id: "applicant-init", paid_by: "Applicant", name: "Single-Application Initiation Fee *", amount: this.props.applicantPackageInitiationFee, due_at: "Initiation" },
    ]

    const bp_fees = this.props.free_initialization ? [] : initiationFees.concat([])

    if (this.props.isRental) {
      bp_fees.push({
        id: "rental",
        paid_by: "Tenant",
        name: "Digital Submission Fee",
        amount: 20,
        due_at: "Submission"
      })
    }

    else if (this.props.isRefinance && !this.props.skipDsfData['skipRefinanceSubmissionFee']) {
      bp_fees.push({
        id: "refinance",
        paid_by: "Shareholder",
        name: "Refinance",
        amount: this.props.refinanceSubmissionFee,
        due_at: this.props.orgHandlesBPFee.refinance ? "Complimentary" : "Submission"
      })
    }

    else if (this.props.isTransfer && !this.props.skipDsfData['skipTransferSubmissionFee']) {
      bp_fees.push({
        id: "transfer",
        paid_by: "Any Transfers",
        name: "Transfer",
        amount: this.props.transferSubmissionFee,
        due_at: this.props.orgHandlesBPFee.transfer ? "Complimentary" : "Submission"
      })
    }

    else if (!this.props.skipDsfData['skipDigitalSubmissionFee']) {
      const isResidential = ['sublet_renewal', 'lease_renewal', 'storage_sale_current_resident', 'parking_sale_current_resident'].includes(this.props.packageType)

      bp_fees.push({
        id: "applicant",
        paid_by: "Applicant",
        name: "Digital Submission Fee",
        amount: this.props.isAlteration ? this.props.alterationSubmissionFee : (isResidential ? this.props.residentialSubmissionFee : this.props.digitalSubmissionFee),
        due_at: this.props.orgHandlesBPFee.applicant ? "Complimentary" : "Submission"
      })
    }

    bp_fees.push({
      id: "admin-fee",
      paid_by: "Any Participant Paying Building Fees",
      name: "App Admin Fee",
      due_at: "Submission",
      amount: [
        <div key="5%">5% of Total</div>,
        <small key="desc">(excluding Digital Submission & Initiation Fees)</small>
      ]
    })

    return bp_fees
  }

  renderNyLL58Compliance() {
    const { enableNy1120b, hasDomecileMailroom, ny1120bPackageTypes, packageType } = this.props
    if (!enableNy1120b || !hasDomecileMailroom) return null
    if (!ny1120bPackageTypes || !ny1120bPackageTypes.includes(packageType)) return null

    return (
      <div>
        <h4 style={{ marginBottom: 0 }} className='dome-p1 dome-color-darkest-grey'>nyc ll 58 compliance</h4>
        <p style={{ paddingLeft: "10px" }} className='dome-p2 dome-color-darkest-grey'>
          This fee covers the registered mail cost of each application acknowledgment,
          required under NYC Local Law 58 of 2026. Each submission — including resubmissions
          for incomplete applications — incurs a separate fee.
        </p>
        <table className="table table-striped building-show-fees margin-left">
          <thead>
            <tr>
              <th>Payor</th>
              <th>Fee</th>
              <th>Amount</th>
              <th>Due Upon</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Buyer</td>
              <td>Registered Mail Fee</td>
              <td>$40</td>
              <td>Submission</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    return <div>
      <h4 style={{ marginBottom: "0" }}>building &amp; management fees</h4>
      <div style={{ paddingLeft: "10px" }}>
        <p> Fees set by and remitted to building and property management company.</p>
      </div>
      {this.renderTable(this.props.fees) }

      {!this.props.hideProcessingFees && (
        <>
          <h4 className="has-bp-logo">processing fees</h4>
          {this.renderTable(this.bp_fees())}
        </>
      )}

      <div style={{padding: "10px"}}>
        <small>* - Only one Application Initiation Fee will be charged. The amount is based on the initiator's identity</small>
      </div>

      {this.renderNyLL58Compliance()}
    </div>
  }

  renderTable(fees) {
    return <table className="table table-striped building-show-fees margin-left">
      <thead>
        <tr>
          <th>Payor</th>
          <th>Building Fees</th>
          <th>Amount</th>
          <th>Due Upon</th>
          { this.props.show_recepient ? <th>Recipient</th> : null}
        </tr>
      </thead>
      <tbody>
        { fees.map(fee => this.renderFeeRow(fee)) }
      </tbody>
    </table>
  }

  renderFeeRow(fee) {
    return <tr key={fee.id}>
      <td className="text-left">{fee.paid_by}</td>
      <td>{ fee.name }</td>
      <td>{ this.renderFeeAmount(fee.amount)}</td>
      <td>{ this.is_third_party_submission(fee) ? "Submission" : fee.due_at}</td>
      { this.props.show_recepient ? fee.recipient_display : null }
    </tr>
  }

  renderFeeAmount(amount) {
    if (typeof amount == "object")
      return amount

    amount = String(amount)
    return amount.match(/[a-z]/i) ? amount : asMoney(amount)
  }
}

Fees.propTypes = {
  fees: PropTypes.array.isRequired,
  skipDsfData: PropTypes.object,
  digitalSubmissionFee: PropTypes.number,
  residentialSubmissionFee: PropTypes.number,
  refinanceSubmissionFee: PropTypes.number,
  transferSubmissionFee: PropTypes.number,
  alterationSubmissionFee: PropTypes.number,
  enableNy1120b: PropTypes.bool,
  hasDomecileMailroom: PropTypes.bool,
  ny1120bPackageTypes: PropTypes.arrayOf(PropTypes.string)
}

export default Fees
